import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string | null;

const slice = createSlice({
  name: '$tagDisplayType',
  initialState,
  reducers: {
    setTagDisplayType(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
});

export const { setTagDisplayType } = slice.actions;
export default slice.reducer;
